import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ButtonComponent } from '../../atoms/button/button.component';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FeedbackCategory } from '../../../enums/feedback-category.enum';
import { IconComponent } from '../../atoms/icon/icon.component';
import { ButtonSize, ButtonSkin, ButtonType } from '../../../enums/button.enum';
import { IconSize } from '../../../enums/icon.enum';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FeedbackClient } from '../../../enums/feedback-client.enum';
import { FeedbackPlatform } from '../../../enums/feedback-platform.enum';

@Component({
  selector: 'app-feedback-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
    ButtonComponent,
    IconComponent,
    FormsModule,
    MatInputModule,
    TranslateModule
  ],
  templateUrl: './feedback-dialog.component.html',
  styleUrl: './feedback-dialog.component.scss'
})
export class FeedbackDialogComponent {
  public ButtonSkin = ButtonSkin;
  public ButtonSize = ButtonSize;
  public ButtonType = ButtonType;
  public IconSize = IconSize;

  form = { title: '', details: '' };
  selectedCategory: FeedbackCategory | null = null;

  options = [
    { category: FeedbackCategory.Feature, label: 'Feature', icon: 'lightbulb-on-outline' },
    { category: FeedbackCategory.Bug, label: 'Bug', icon: 'bug-outline' },
    { category: FeedbackCategory.Usability, label: 'Usability', icon: 'gesture-tap-button' }, // No outline available
    { category: FeedbackCategory.Content, label: 'Content', icon: 'file-document-edit-outline' },
    { category: FeedbackCategory.Performance, label: 'Performance', icon: 'speedometer' }, // No outline
    { category: FeedbackCategory.General, label: 'General', icon: 'message-text-outline' },
  ];

  constructor(public dialogRef: MatDialogRef<FeedbackDialogComponent>) {}

  get selected() {
    return this.options.find(opt => opt.category === this.selectedCategory)!;
  }

  select(option: { category: FeedbackCategory }) {
    this.selectedCategory = option.category;
  }

  reset() {
    this.selectedCategory = null;
    this.form = { title: '', details: '' };
  }

  submit() {
    if (!this.selectedCategory) return;

    const trimmedTitle = this.form.title.trim();
    const trimmedDetails = this.form.details.trim();

    if (trimmedTitle && trimmedDetails) {
      this.dialogRef.close({
        category: this.selectedCategory,
        title: trimmedTitle,
        details: trimmedDetails,

        // NEW
        client: FeedbackClient.AngularWeb,
        platform: FeedbackPlatform.Web
      });
    }
  }
}
